import(/* webpackMode: "eager" */ "/var/www/joy-awards-frontend-v3/src/app/global-error.tsx");
